export default __webpack_public_path__ + "static/banner-image-c0b838fa2e43b98de4dd710b8ec06b84.jpg";